import request from '@/utils/request'

const PAGE_SIZE_DEFAULT = 10

/**
 * 查询资讯分类列表（分页）
 * @param {Object} params {page: 1基页码, row: 每页条数, typeName: 可选模糊查询}
 */
export function listAreaNewsTypes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.listAreaNewsTypes',
      method: 'post',
      data: {
        page: params.page - 1,
        row: params.row || PAGE_SIZE_DEFAULT,
        typeName: params.typeName || ''
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data)
      } else {
        reject(new Error(res.msg || '查询资讯分类失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 新增资讯分类
 * @param {Object} data {typeName, seq}
 */
export function saveAreaNewsType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.saveAreaNewsType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '新增资讯分类失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 修改资讯分类
 * @param {Object} data {typeId, typeName, seq, statusCd}
 */
export function updateAreaNewsType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.updateAreaNewsType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '修改资讯分类失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 删除资讯分类（SMO 校验：分类下存在文章则拒删）
 * @param {Object} data {typeId}
 */
export function deleteAreaNewsType(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.deleteAreaNewsType',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除资讯分类失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 查询资讯文章列表（分页；state 不传=全部）
 * @param {Object} params {page: 1基页码, row, title, typeId, areaId, state}
 */
export function listAreaNews(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.listAreaNews',
      method: 'post',
      data: {
        page: params.page - 1,
        row: params.row || PAGE_SIZE_DEFAULT,
        title: params.title || '',
        typeId: params.typeId || '',
        areaId: params.areaId || '',
        state: params.state || ''
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res.data)
      } else {
        reject(new Error(res.msg || '查询资讯列表失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 查询资讯详情（编辑回显用）
 * 后台无独立详情 Cmd，用 listAreaNews 精确查单条（XML 已支持 newsId 条件）
 * @param {String} newsId
 */
export function queryAreaNewsDetail(newsId) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.listAreaNews',
      method: 'post',
      data: { page: 0, row: 1, newsId: newsId }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        const _list = (res.data && res.data.newsList) || []
        if (_list.length > 0) {
          resolve(_list[0])
        } else {
          reject(new Error('资讯不存在或已删除'))
        }
      } else {
        reject(new Error(res.msg || '查询资讯详情失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 新增资讯文章（保存草稿 state=1000）
 * @param {Object} data {title, typeId, areaId, communityId, source, summary, headerImg, content, isTop}
 */
export function saveAreaNews(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.saveAreaNews',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '新增资讯失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 修改资讯文章（state=2000 时 title/typeId/areaId/content 必填，SMO 校验）
 * @param {Object} data 同 saveAreaNews + newsId
 */
export function updateAreaNews(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.updateAreaNews',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '修改资讯失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 删除资讯文章（仅草稿 1000/已下架 3000 可删，SMO 校验，物理删）
 * @param {Object} data {newsId}
 */
export function deleteAreaNews(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.deleteAreaNews',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除资讯失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 发布资讯（校验必填 → state=2000 + publish_time=NOW()）
 * @param {Object} data {newsId}
 */
export function publishAreaNews(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.publishAreaNews',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '发布资讯失败'))
      }
    }).catch(err => reject(err))
  })
}

/**
 * 下架资讯（state=3000）
 * @param {Object} data {newsId}
 */
export function offAreaNews(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaNews.offAreaNews',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '下架资讯失败'))
      }
    }).catch(err => reject(err))
  })
}
